




























































































































































import { Component, Vue} from 'vue-property-decorator';
import axios from 'axios';
import { General } from '@/services/General';
import SearchFilter from '@/components/Utilities/SearchFilter.vue';
import LeftClickOptionMenu from "@/components/Utilities/LeftClickOptionMenu.vue";
import { i18n } from '@/i18n/i18n-setup';
import { getDropDownStatusList, PlanHeader } from '@/entity/Ppe/PlanHeader';
import { PPE_PRODUCT_TYPE } from '@/services/Enums';
import PlanProductsDetail from './PlanProductsDetail.vue';
import PlanDetails from './PlanDetails.vue';
import { GetDropdownCountriesForUser } from '@/services/PpeDropDowns';

@Component({
    components: {
        SearchFilter,
        PlanProductsDetail,
        LeftClickOptionMenu,
        PlanDetails
    },
})
export default class PlansSearch extends Vue {        
    idPlanDetail: any = null;
    numericIdSelected: number = null;
    productsType: number = null;

    showLoading: boolean = false;
    ready: boolean = false;
    planDetailEditMode: boolean = false;

    // advanced search
    resultsItems: any = {
        resultPage: new Array<PlanHeader>(),
        total: 0
    };
    page: number = 1;
    firstSearch: boolean = false;
    freeText = null;
    filterSelected: boolean = false;
    advNumericId: number = null;
    advTitle: string = null;
    advNumber: string = null;
    advCountry: string = null;
    advYear: string = null;
    advStatus: string = null;

    dropDownCountries: any = new Array();  
    dropDownCountriesSubsidiary: any = new Array();
    dropDownCountriesProp: any = new Array();
    dropDownStatus: any = new Array(); 
    
    productsTypeEnum: any = PPE_PRODUCT_TYPE;

    //pacchetto per menu tasto destro su dettaglio entita'
    leftClickOptionMenuUrl: string = "/ppes/";
    leftClickOptionMenuUrlArgument: string = "numericId";
    handleClick (event, item) {
        (this.$refs.leftClickOptions as LeftClickOptionMenu).handleClick(event, item);
    }

    async mounted() {
        this.dropDownStatus = getDropDownStatusList();
        this.dropDownCountries = await GetDropdownCountriesForUser();
        this.dropDownCountriesSubsidiary = await GetDropdownCountriesForUser(true);

        if (this.$route.params.id) {
            let app: any = this;
            let planNumericId: string = this.$route.params.id;
            let promise = this.getPlanByNumericId(planNumericId);                
            promise.then(function (val) {
                let customer: any = {
                    numericId: planNumericId,
                    id: val
                };
                app.dropDownCountriesProp = app.dropDownCountries;
                app.openPlan(customer, true);
            });
        }
        
        this.ready = true;
    }

    checkFilterParameter(){
        if(this.AdvancedSearchFilled)
            this.filterSelected = true;
        else
            this.filterSelected = false;
    }

    get PlanDetailModalTitle(): string {
        if(this.numericIdSelected != null)
            return `${i18n.t('PPE.PLAN') as string}: ${this.numericIdSelected}`;
        else
            return i18n.t('PPE.NEW_PLAN') as string;
    }

    get planProductsDetailModalTitle(): string {
        let title: string = "";
        switch(this.productsType) {
            case PPE_PRODUCT_TYPE.INCLUDED:
                title = `${i18n.t('PPE.PLAN_PRODUCTS_INCLUDED') as string}: ${this.numericIdSelected}`;
                break;
            case PPE_PRODUCT_TYPE.EXCLUDED:
                title = `${i18n.t('PPE.PLAN_PRODUCTS_EXCLUDED') as string}: ${this.numericIdSelected}`;
                break;
            case PPE_PRODUCT_TYPE.COST_ALLOCATION:
                title = `${i18n.t('PPE.PLAN_PRODUCTS_COST_ALLOCATION') as string}: ${this.numericIdSelected}`;
                break;
        }
        return title;
    }

    CheckIsNullOrEmpty(text: any) {
        if (text == null) return true;
        if (text == '') return true;
        return false;
    }

    get AdvancedSearchFilled(): boolean {      
        return this.CheckAdvancedSearchFilled();
    }

    CheckAdvancedSearchFilled(): boolean {
        if (!this.CheckIsNullOrEmpty(this.advCountry)) return true;     
        if (!this.CheckIsNullOrEmpty(this.advNumber)) return true;
        if (!this.CheckIsNullOrEmpty(this.advNumericId)) return true;
        if (!this.CheckIsNullOrEmpty(this.advStatus)) return true;
        if (!this.CheckIsNullOrEmpty(this.advTitle)) return true;
        if (!this.CheckIsNullOrEmpty(this.advYear)) return true;
        return false;
    }

    CheckSearchFilled() {
        if(!this.CheckIsNullOrEmpty(this.freeText)) return true;
        if(this.CheckAdvancedSearchFilled()) return true;
        return false;     
    }

    resetFilters() {
        this.advCountry = null;
        this.advNumber = null;
        this.advNumericId = null;
        this.advStatus = null;
        this.advTitle = null;
        this.advYear = null;
        this.filterSelected = false;
    }

    async getAndOpenPlan(numericId: string) {
        let app: any = this;
        let promise = this.getPlanByNumericId(numericId);                
        promise.then(function (val) {
            let customer: any = {
                numericId: numericId,
                id: val
            };
            app.dropDownCountriesProp = app.dropDownCountries;
            app.openPlan(customer, false);
        });
    }

    async postAddingPlan(numericId: string) {
        this.getAndOpenPlan(numericId);
    }

    async postUpdatingPlan(numericId: string) {
        this.getAndOpenPlan(numericId);
    }

    handleUnauthorizedUser() {
        this.close();

        let newPath = '/ppes/'
        if (this.$route.path !== newPath) 
            this.$router.push(newPath);

        General.showAlertDanger(i18n.t('GENERIC.MSG_UNAUTHORIZED_USER') as string,this);
    }

    async getPlanByNumericId(numericId: string) {
        let idPlan: string = null;

        try {
            let response = await axios({
                method: 'get',
                url: General.GetApiUrl('/api/ppe/GetPlanIdByNumericId?numericId=' + numericId),
                responseType: 'json',
                withCredentials: true
            });
            idPlan = response.data;
        } catch (error) {
            General.HandleError(error, this);
        }
        return idPlan;
    }

    openPlanProductsDetail(planHeaderId: string, numericId: number, productsType: number) {
        this.idPlanDetail = planHeaderId;
        this.numericIdSelected = numericId;
        this.productsType = productsType;
        this.$bvModal.show('plan-products-modal');
    }

    openPlan(plan: any, forceOpen: boolean) {
        let newPath = '/ppes/' + plan.numericId;
        if (!forceOpen && this.$route.path !== newPath) 
            this.$router.push(newPath);

        this.planDetailEditMode = true;
        this.idPlanDetail = plan.id;
        this.numericIdSelected = plan.numericId;
        this.dropDownCountriesProp = this.dropDownCountries;
        this.$bvModal.show('plan-details-modal');
    }

    createPlan() {
        this.planDetailEditMode = false;
        this.idPlanDetail = null;
        this.numericIdSelected = null;
        this.dropDownCountriesProp = this.dropDownCountriesSubsidiary;
        this.$bvModal.show('plan-details-modal');
    }

    close() {
        this.$bvModal.hide('plan-details-modal');
    }
    
    resetSearch() {
        this.firstSearch = false;
        this.resultsItems.resultPage.splice(0);
        this.page = 1;
    }

    searchFilterSearchEvent(genericSearch: string) {
        if (genericSearch != null) 
            this.freeText = genericSearch;
        
        this.searchItems(true)
    }

    searchFilterResertEvent() {
        this.resetFilters()
    }

    searchItems(start: boolean) {
        this.searchPlansDo(start);
    }

    async searchPlansDo(start: boolean) {
        this.showLoading = true;
        if (start == true)
            this.resetSearch();
        try {
            let results: any = await axios({
                method: 'post',
                url: General.GetApiUrl('/api/ppe/GetPlansWithFilterAndPagination'),
                data: {
                    FreeText: this.freeText,
                    NumericId: this.advNumericId,
                    Title: this.advTitle,
                    Number: this.advNumber,
                    IdCountryFrom: this.advCountry,
                    Status: this.advStatus,
                    Year: this.advYear,
                    CurrentPage: this.page
                },
                withCredentials: true,
                responseType: 'json'
            });
           
            this.resultsItems.resultPage = this.resultsItems.resultPage.concat(results.data.listPage);
            this.resultsItems.total = results.data.total;

            this.firstSearch = true;
            this.page += 1;
            
            this.showLoading = false;
        } catch (error) {
            General.HandleError(error, this);
            this.showLoading = false;
        }

    }
}
